var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error-license-admin-no-license" },
    [
      _c(
        "error-license-lock",
        {
          attrs: {
            title: _vm.$t.__(
              "pages.errors.ErrorLicenseAdminNoLicense.no_licence_available"
            ),
            subtitles: [
              _vm.$t.__(
                "pages.errors.ErrorLicenseAdminNoLicense.to_use_contact_subscription_owner"
              ),
              _vm.$t.__(
                "pages.errors.ErrorLicenseAdminNoLicense.can_update_subscription"
              )
            ]
          }
        },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.labels.buttons.update_subscription,
              size: "large"
            },
            on: {
              click: function($event) {
                return _vm.goToUrl(
                  "/?_f=accountPreferences&action=subscription"
                )
              }
            }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass:
              "error-license-admin-no-license__support typographies-paragraph-medium-semibold",
            domProps: { innerHTML: _vm._s(_vm.labels.chat) }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }